import { mapFromAuditCriteriaSetDTO } from 'mappings/auditCriteriaMapping';
import {
  TemplateCriteriaImportPreview,
  TemplateCriteriaImportRequest,
  TemplateCriteriaImportResult,
  TemplateCriteriaImportRow,
} from 'models/templateCriteriaImport';
import {
  TemplateCriteriaImportPreviewDTO,
  TemplateCriteriaImportRequestDTO,
  TemplateCriteriaImportResultDTO,
  TemplateCriteriaImportRowDTO,
} from 'models/dto/templateCriteriaImportDTO';

// PLAN-CTI-081: the template import's request, preview and result.

export function mapToTemplateCriteriaImportRequestDTO(
  request: TemplateCriteriaImportRequest,
): TemplateCriteriaImportRequestDTO {
  const dto = new TemplateCriteriaImportRequestDTO();
  dto.taskId = request.taskId;
  dto.includeChecklist = request.includeChecklist;
  dto.includeForm = request.includeForm;
  dto.verification = request.verification;

  return dto;
}

function mapFromTemplateCriteriaImportRowDTO(dto: TemplateCriteriaImportRowDTO): TemplateCriteriaImportRow {
  const output = new TemplateCriteriaImportRow();
  output.source = dto.source ?? '';
  output.sourceIndex = dto.sourceIndex ?? 0;
  output.sourceName = dto.sourceName ?? '';
  output.requirement = dto.requirement ?? '';
  output.successCriteria = dto.successCriteria ?? '';
  output.columnName = dto.columnName ?? '';
  output.requiresComment = dto.requiresComment ?? false;
  output.requiresEvidence = dto.requiresEvidence ?? false;
  output.status = dto.status ?? '';
  output.reason = dto.reason ?? '';
  output.existingCriterionKey = dto.existingCriterionKey ?? '';
  output.existingState = dto.existingState ?? '';
  output.duplicateOfSource = dto.duplicateOfSource ?? '';
  output.duplicateOfSourceIndex = dto.duplicateOfSourceIndex ?? 0;

  return output;
}

export function mapFromTemplateCriteriaImportPreviewDTO(
  dto: TemplateCriteriaImportPreviewDTO,
): TemplateCriteriaImportPreview {
  const output = new TemplateCriteriaImportPreview();
  output.templateName = dto.templateName ?? '';
  output.templateTaskType = dto.templateTaskType ?? 0;
  output.rows = (dto.rows ?? []).map(mapFromTemplateCriteriaImportRowDTO);
  output.newCount = dto.newCount ?? 0;
  output.duplicateCount = dto.duplicateCount ?? 0;
  output.notConvertedCount = dto.notConvertedCount ?? 0;

  return output;
}

export function mapFromTemplateCriteriaImportResultDTO(
  dto: TemplateCriteriaImportResultDTO,
): TemplateCriteriaImportResult {
  const output = new TemplateCriteriaImportResult();
  if (dto.preview) output.preview = mapFromTemplateCriteriaImportPreviewDTO(dto.preview);
  output.set = dto.set ? mapFromAuditCriteriaSetDTO(dto.set) : undefined;

  return output;
}
